import React from 'react';
import { Button, Divider } from '@dls/react-core';
import styled from 'styled-components';

const StyledFooterContainer = styled.div`
  display: flex;
  margin-top: 32px;
  flex-direction: column;
`;

const StyledFooterButtonContainer = styled.div`
  display: flex;
  padding: 24px 0 0 0;
  justify-content: space-between;
`;

interface FormFooterProps {
  isSubmitting: boolean;
  isSubmitDisabled?: boolean;
  onCancel: () => void;
  cancelButtonText?: string;
  submitButtonText?: string;
}

export const FormFooter: React.FC<FormFooterProps> = ({
  isSubmitting,
  isSubmitDisabled,
  onCancel,
  cancelButtonText,
  submitButtonText,
}) => {
  return (
    <StyledFooterContainer>
      <Divider
        orientation="horizontal"
        className="DLS-divider-horizontal"
        flexItem
        style={{ width: `100%`, height: `1px` }}
      />
      <StyledFooterButtonContainer>
        <Button
          disabled={isSubmitting}
          dls_variant="quietEmphasis"
          onClick={onCancel}
          style={{ marginRight: 5, width: `12rem` }}
        >
          {cancelButtonText || 'Cancel'}
        </Button>
        <Button
          type="submit"
          disabled={isSubmitDisabled || isSubmitting}
          dls_variant="primary"
          data-testid={'submit-button'}
          style={{ marginRight: 5, width: `12rem` }}
        >
          {submitButtonText || 'Submit'}
        </Button>
      </StyledFooterButtonContainer>
    </StyledFooterContainer>
  );
};
